import { SVGProps } from 'react'

// [FIXME] {JusIABrandLogo} this component will be replaced by the new Farol component. @andersonba

export type JusAILogoProps = SVGProps<SVGSVGElement>

export const JusAILogo = (props: JusAILogoProps) => {
  const textColor = 'var(--fds-c-brand-text-color-positive)'
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 243 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_91_1230)">
        <path
          d="M64.29 66.4V60.76C67.15 62.76 70.23 63.77 73.52 63.77C76.81 63.77 79.36 62.93 80.87 61.26C82.37 59.59 83.12 56.84 83.12 53.03V18.55H88.54V53.47C88.54 56.52 88.11 59.13 87.26 61.29C86.4 63.45 85.24 65.06 83.76 66.11C82.28 67.16 80.77 67.91 79.22 68.35C77.67 68.79 76 69.01 74.22 69.01C70.63 69.01 67.32 68.14 64.29 66.41V66.4Z"
          fill={textColor}
        />
        <path
          d="M99.3701 52.66V30.97H104.79V52.91C104.79 56.71 105.62 59.5 107.28 61.26C108.94 63.03 111.53 63.91 115.07 63.91C118.61 63.91 121.14 63.03 122.83 61.26C124.51 59.49 125.35 56.71 125.35 52.91V30.97H130.77V52.66C130.77 57.86 129.4 61.89 126.67 64.73C123.94 67.58 120.07 69 115.07 69C110.07 69 106.2 67.58 103.47 64.73C100.74 61.88 99.3701 57.86 99.3701 52.66Z"
          fill={textColor}
        />
        <path
          d="M137.13 41.13C137.13 38.14 138.22 35.59 140.41 33.48C142.6 31.37 145.94 30.31 150.43 30.31C153.63 30.31 156.83 31.07 160.03 32.59V37.98C157.17 36.27 154.17 35.41 151.02 35.41C145.38 35.41 142.56 37.32 142.56 41.14C142.56 42.44 143.24 43.49 144.61 44.28C145.98 45.08 147.65 45.74 149.63 46.26C151.61 46.79 153.59 47.42 155.57 48.15C157.55 48.89 159.23 50.13 160.61 51.88C161.99 53.63 162.68 55.87 162.68 58.58C162.68 61.83 161.46 64.38 159.03 66.23C156.6 68.08 153.23 69 148.93 69C144.63 69 141 68.06 137.61 66.18V60.45C141.2 62.65 144.9 63.76 148.71 63.76C154.4 63.76 157.25 62.03 157.25 58.58C157.25 56.72 156.57 55.26 155.2 54.21C153.83 53.16 152.16 52.37 150.18 51.84C148.2 51.31 146.22 50.74 144.24 50.11C142.26 49.48 140.58 48.43 139.2 46.95C137.82 45.47 137.13 43.53 137.13 41.13Z"
          fill={textColor}
        />
        <path d="M181.16 67.83V18.55H187.98V67.84H181.16V67.83Z" fill={textColor} />
        <path
          d="M196.21 67.83L215.87 18.54H222.58L242.17 67.83H234.77L229.47 53.94H208.9L203.6 67.83H196.2H196.21ZM211.36 47.59H227.02L219.19 27.13L211.36 47.59Z"
          fill={textColor}
        />
        <path
          d="M56.2101 0H27.2701C26.1701 0 25.2401 0.79 25.0501 1.87L24.2801 6.3C24.2801 6.3 24.2801 6.33 24.2701 6.35L18.8901 37.14H31.2401C32.0801 37.14 32.8501 37.6 33.2501 38.34L47.0901 64.5C47.0901 64.5 47.2601 64.82 47.3101 65.08C47.3401 65.24 47.3601 65.36 47.3701 65.46C47.3701 65.47 47.3701 65.48 47.3701 65.49C47.3701 65.53 47.3701 65.56 47.3701 65.59C47.3701 65.69 47.3701 65.8 47.3701 65.8C47.3701 65.87 47.3601 65.95 47.3401 66.02C47.3401 65.99 47.3601 65.96 47.3601 65.93L57.6601 7.14L58.4501 2.66C58.6901 1.27 57.6201 0 56.2101 0Z"
          fill="#FFCC00"
        />
        <path
          d="M13.95 66.1C13.95 66.1 13.95 66.1 13.95 66.09C13.94 66.03 13.93 65.96 13.92 65.9C13.92 65.89 13.92 65.88 13.92 65.87C13.92 65.81 13.92 65.75 13.92 65.69C13.92 65.67 13.92 65.65 13.92 65.63C13.92 65.58 13.92 65.52 13.92 65.47C13.92 65.43 13.92 65.4 13.93 65.36C13.93 65.32 13.93 65.28 13.94 65.24C13.95 65.16 13.97 65.08 13.99 65L18.88 37.15H2.26002C0.55002 37.15 -0.539979 38.98 0.270021 40.48L14.11 66.64C14.11 66.64 14.13 66.66 14.13 66.67C14.04 66.49 13.98 66.3 13.95 66.1Z"
          fill="#3D82DA"
        />
        <path
          d="M47.3598 65.8C47.2698 67.04 46.1098 67.85 45.1498 67.84H43.5398H16.2298C15.8498 67.84 15.4598 67.74 15.4598 67.74C14.2598 67.42 13.6898 66.31 13.9998 64.99L18.8898 37.14H31.2398C32.0798 37.14 32.8498 37.6 33.2498 38.34L47.0898 64.5C47.0898 64.5 47.2598 64.82 47.3098 65.08C47.3598 65.34 47.3698 65.48 47.3698 65.59C47.3698 65.7 47.3698 65.8 47.3698 65.8H47.3598Z"
          fill="#77B340"
        />
      </g>
    </svg>
  )
}
